module.exports = __webpack_public_path__ + "static/media/nunito_extrabold.0ded1fa6.ttf";